export const sidebarMenuConfig = [
    // {
    //     label: "Platform",
    //     items: [
    //         {
    //             menuKey: "dashboard",
    //             menuTitle: "Dashboard",
    //             menuIcon: "lucide:layout-dashboard",
    //             navigationPath: "/dashboard",
    //         },
    //         {
    //             menuKey: "uicomponents",
    //             menuTitle: "UI Components",
    //             menuIcon: "streamline-freehand-color:design-tool-pen-brush-cup",
    //             navigationPath: "/uicomponents",
    //         },
    //     ],
    // },
    {
        label: "Management",
        items: [
            {
                menuKey: "adminScholarships",
                menuTitle: "Scholarship Admin",
                menuIcon: "solar:settings-outline",
                navigationPath: "/admin/scholarships",
            },
            {
                menuKey: "scholarship",
                menuTitle: "Scholarship",
                menuIcon: "solar:bill-list-outline",
                navigationPath: "/scholarship",
            },
            {
                menuKey: "myApplications",
                menuTitle: "My Applications",
                menuIcon: "solar:bill-list-outline",
                navigationPath: "/my-applications",
            },
            {
                menuKey: "applicationsManagement",
                menuTitle: "Scholarship Applications",
                menuIcon: "solar:bill-list-outline",
                navigationPath: "/scholarship-applications",
            },
            // {
            //     menuKey: "formbuilder",
            //     menuTitle: "Form Builder",
            //     menuIcon: "lucide:form",
            //     navigationPath: "/formbuilder",
            // },
            // {
            //     menuKey: "gridbuilder",
            //     menuTitle: "Grid Builder",
            //     menuIcon: "tabler:table-filled",
            //     navigationPath: "/gridbuilder",
            // },
            // {
            //     menuKey: "scholarship",
            //     menuTitle: "Scholarship",
            //     menuIcon: "solar:bill-list-outline",
            //     navigationPath: "/scholarship",
            // },
            // {
            //     menuKey: "userManagement",
            //     menuTitle: "User Management",
            //     menuIcon: "si:user-alt-5-fill",
            //     children: [
            //         {
            //             menuKey: "exception",
            //             subMenuName: "Exception",
            //             navigationPath: "/analytics/exception",
            //         }
            //     ],
            // },
        ],
    }
];
